import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import PreviewAttachments from '../../../../components/Preview/Attachments'
import PreviewDescription from '../../../../components/Preview/Description'
import DocumentToComplete from '../../../../components/Preview/DocumentToComplete'
import PreviewTitle from '../../../../components/Preview/Title'

const Preview = () => {
  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />

      <DocumentToComplete />
    </Box>
  )
}

export default Preview
